export default "__VITE_PUBLIC_ASSET__6034685f__"